exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Instructions{transition-delay:0.1s;transition-duration:1s;background-color:#b51218;border-color:#b51218;border-width:2px;z-index:1036}.Instructions .popover-header{color:#fff;display:flex;flex-wrap:wrap-reverse;justify-content:space-between;background-color:transparent;font-weight:bold;border-style:none}.Instructions .popover-header .instructions-hide{font-size:85%;color:#eee;font-weight:normal;cursor:pointer}.Instructions .popover-body{background-color:#2e2e2e;color:#fff;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.Instructions.bs-popover-top .arrow:after{border-top-color:#b51218}\n", ""]);

// exports
